/* Optional attribution. It cannot grant consent, submit forms or publish events. */
(() => {
  'use strict';
  if (window.PinmeEmailAttribution) return;
  const keyPrefix = 'pinme.email.attribution.v1';
  const key = (() => {
    try {
      const theme = window.Shopify?.theme, params = new URL(location.href).searchParams;
      if (String(theme?.role || '').toLowerCase() === 'main' && !window.Shopify?.designMode && !['preview_theme_id','preview_key','_fd','_ab'].some(name => params.has(name))) return keyPrefix;
      const themeId = String(theme?.id || params.get('preview_theme_id') || '');
      return keyPrefix + ':preview:' + (/^\d+$/.test(themeId) ? themeId : 'unknown');
    } catch (_) { return keyPrefix + ':preview:unknown'; }
  })();
  const lifetime = 90 * 86400 * 1000;
  const hosts = new Set(['pinmetoys.com', 'www.pinmetoys.com', 'yicezd-ue.myshopify.com']);
  const utmFields = { utm_source:'utmSource', utm_medium:'utmMedium', utm_campaign:'utmCampaign', utm_content:'utmContent', utm_term:'utmTerm' };
  let memory = null, observedTouch = '', loadingPrivacy = false;
  const object = value => value && typeof value === 'object' && !Array.isArray(value) ? value : null;
  function permissions() {
    const result = { analytics:false, marketing:false, advertising:false };
    try {
      const privacy = window.Shopify?.customerPrivacy;
      result.analytics = privacy?.analyticsProcessingAllowed?.() === true;
      result.marketing = privacy?.marketingAllowed?.() === true;
      // Keep the existing, stricter third-party advertising gate independent.
      result.advertising = result.analytics && result.marketing && privacy?.saleOfDataAllowed?.() === true;
    } catch (_) {}
    return result;
  }
  function permission() {
    try {
      const privacy = window.Shopify?.customerPrivacy;
      return typeof privacy?.marketingAllowed === 'function' ? privacy.marketingAllowed() === true : null;
    } catch (_) { return null; }
  }
  function forget() {
    memory = null; observedTouch = '';
    try {
      const keys = [keyPrefix, ...Array.from({length:localStorage.length}, (_, index) => localStorage.key(index)).filter(name => name?.startsWith(keyPrefix + ':preview:'))];
      for (const name of keys) { try { localStorage.removeItem(name); } catch (_) {} }
    } catch (_) { try { localStorage.removeItem(key); } catch (_) {} }
  }
  function allowed() {
    const result = permission();
    if (result === false) forget();
    return result === true;
  }
  function campaign(value) {
    if (typeof value !== 'string' || value.length > 2048) return undefined;
    const clean = value.replace(/[\u0000-\u001f\u007f]/g, '').trim();
    let decoded = clean;
    for (let stage = 0; stage < 4; stage++) {
      if (!decoded || /[@<>\u0000-\u001f\u007f]|(?:https?:|www\.)|\b(?:email|phone|token|authorization|password|address|contact|fbclid|gclid|dclid|msclkid|ttclid|wbraid|gbraid)\s*[:=]|\bBearer\s+|\beyJ[A-Za-z0-9_-]+\.[A-Za-z0-9_-]+\.[A-Za-z0-9_-]+/i.test(decoded) || /^\+?[\d\s().-]{7,}$/.test(decoded)) return undefined;
      if (!decoded.includes('%')) return clean.slice(0, 128);
      try { decoded = decodeURIComponent(decoded); } catch (_) { return undefined; }
    }
    return undefined;
  }
  const metaSources = new Set(['fb','ig','facebook','instagram','meta','messenger','msg','an','audience_network']);
  const metaAdId = value => typeof value === 'string' && /^[1-9][0-9]{9,29}$/.test(value);
  function campaignFields(input, explicit = {}) {
    const result = {};
    for (const field of Object.values(utmFields)) { const clean = campaign(input[field]); if (clean) result[field] = clean; }
    const meta = metaSources.has(String(result.utmSource || '').trim().toLowerCase()) && String(result.utmMedium || '').trim().toLowerCase() === 'paid_social';
    const fields = ['utmContent','utmTerm'];
    const consistent = fields.every(field => explicit[field] === undefined || (metaAdId(explicit[field]) && (!metaAdId(input[field]) || explicit[field] === input[field])));
    if (meta && consistent) for (const field of fields) { if (metaAdId(input[field])) result[field] = input[field]; }
    return result;
  }
  function queryCampaign(params) {
    const input = {}, explicit = {};
    for (const [param, field] of Object.entries(utmFields)) {
      const values = params.getAll(param);
      if (values.some(value => value !== values[0])) return {};
      input[field] = values[0];
    }
    for (const [param, field] of Object.entries({ad_id:'utmContent',adset_id:'utmTerm'})) {
      const values = params.getAll(param);
      if (values.length) explicit[field] = values.every(value => value === values[0]) ? values[0] : null;
    }
    return campaignFields(input, explicit);
  }
  function safeUrl(value, referrer = false) {
    if (typeof value !== 'string' || value.length > 2048) return undefined;
    try {
      const url = new URL(value);
      if (!['https:', 'http:'].includes(url.protocol)) return undefined;
      if (!hosts.has(url.hostname)) return referrer ? url.origin : undefined;
      const publicPath = /^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?(?:(?:products|pages|collections)\/[a-z0-9-]{1,160}\/?)?$/i.test(url.pathname) ? url.pathname : '/';
      return url.origin + publicPath;
    } catch (_) { return undefined; }
  }
  function market(value) {
    const input = object(value) || {}, result = {};
    if (typeof input.selectedCountry === 'string' && /^[a-z]{2}$/i.test(input.selectedCountry)) result.selectedCountry = input.selectedCountry.toUpperCase();
    if (typeof input.currency === 'string' && /^[a-z]{3}$/i.test(input.currency)) result.currency = input.currency.toUpperCase();
    if (typeof input.marketId === 'string' && /^(?:gid:\/\/shopify\/Market\/)?[1-9][0-9]{0,19}$/.test(input.marketId)) result.marketId = input.marketId;
    return result;
  }
  function touch(value) {
    const input = object(value); if (!input) return null;
    const result = market(input);
    Object.assign(result, campaignFields(input));
    const landing = safeUrl(input.landingUrl), referrer = safeUrl(input.referrerUrl, true);
    if (landing) result.landingUrl = landing;
    if (referrer) result.referrerUrl = referrer;
    const time = typeof input.capturedAt === 'string' ? Date.parse(input.capturedAt) : NaN;
    if (!Number.isFinite(time) || time < Date.now() - lifetime || time > Date.now() + 300000) return null;
    result.capturedAt = new Date(time).toISOString();
    return Object.keys(result).some(field => field !== 'capturedAt') ? result : null;
  }
  function read() {
    if (!allowed()) return null;
    try {
      const stored = JSON.parse(localStorage.getItem(key) || 'null');
      if (stored?.version === 1) {
        const first = touch(stored.first), latest = touch(stored.latest);
        memory = first || latest ? { version:1, ...(first ? {first} : {}), ...(latest ? {latest} : {}) } : null;
      }
    } catch (_) { /* Private browsing can block storage; in-page observation remains optional. */ }
    if (memory) {
      const first = touch(memory.first), latest = touch(memory.latest);
      memory = first || latest ? { version:1, ...(first ? {first} : {}), ...(latest ? {latest} : {}) } : null;
    }
    return memory;
  }
  function save(value) {
    if (!allowed()) return;
    memory = value;
    try { localStorage.setItem(key, JSON.stringify(value)); } catch (_) {}
  }
  function config(scope = document) {
    try { return JSON.parse(scope.querySelector('[data-email-interest-config]')?.textContent || 'null')?.attributionContext; }
    catch (_) { return null; }
  }
  function observe(context) {
    try {
      if (!allowed()) return;
      const url = new URL(location.href);
      if (!hosts.has(url.hostname) || !['https:', 'http:'].includes(url.protocol)) return;
      // Do not turn a Shopify verification/return into a new ad touch.
      if (['mn_signup', 'pn_signup', 'customer_posted', 'contact_posted'].some(name => url.searchParams.has(name)) || /^\/(?:challenge|account|checkout|checkouts|orders|contact)(?:\/|$)/i.test(url.pathname)) return;
      const previous = read(), current = { ...market(context), landingUrl:safeUrl(url.href), capturedAt:new Date().toISOString() };
      const referrer = safeUrl(document.referrer, true); if (referrer) current.referrerUrl = referrer;
      const campaign = queryCampaign(url.searchParams), hasCampaign = Object.keys(campaign).length > 0;
      Object.assign(current, campaign);
      const signature = JSON.stringify({ landingUrl:current.landingUrl, ...Object.fromEntries(Object.values(utmFields).filter(field => current[field]).map(field => [field, current[field]])) });
      if (observedTouch === signature) return;
      observedTouch = signature;
      if (!previous) save({ version:1, first:current, latest:current });
      else if (hasCampaign) save({ version:1, first:previous.first || previous.latest, latest:current });
    } catch (_) { /* Optional context must never block signup. */ }
  }
  function snapshot(context) {
    try {
      if (!allowed()) return undefined;
      observe(context);
      const value = read(); if (!value) return undefined;
      const latest = { ...(value.latest || value.first), ...market(context), capturedAt:new Date().toISOString() };
      return JSON.parse(JSON.stringify({ version:1, ...(value.first ? {first:value.first} : {}), latest }));
    } catch (_) { return undefined; }
  }
  function init(scope = document) {
    observe(config(scope) || config());
    if (permission() === null && !loadingPrivacy && typeof window.Shopify?.loadFeatures === 'function') {
      loadingPrivacy = true;
      try { window.Shopify.loadFeatures([{ name:'consent-tracking-api', version:'0.2' }], error => { if (!error) observe(config()); }); } catch (_) {}
    }
  }
  window.PinmeEmailAttribution = { snapshot, observe, allowed, permissions };
  document.addEventListener('visitorConsentCollected', () => init());
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('submit', event => observe(config(event.target) || config()), { capture:true, passive:true });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), { once:true });
  else init();
})();

/* Existing signup transport follows. Optional attribution is not consent. */

(() => {
  'use strict';
  if (window.PinmeEmailInterests) return;
  const guests = new Map(), requests = new WeakMap(), controllers = new Map();
  const pendingLeads = new Map(), publishedLeads = new Set(), publishingLeads = new Set();
  // TikTok receives only server-confirmed new interests. This transport is independent
  // of Shopify/Meta, and every tracking failure leaves the signup result unchanged.
  const tiktokQueue = new Map(), tiktokSent = new Map();
  const tiktokContextKey = 'pinme.tiktok.click.v1', tiktokSentKey = 'pinme.tiktok.sent.v1';
  const tiktokMaxAge = 900, tiktokRetryDelays = [1000, 3000, 10000, 30000];
  let tiktokTimer = null, tiktokContext = null;
  function tiktokPrivacy() {
    try {
      const p = window.Shopify?.customerPrivacy;
      const names = ['marketingAllowed','analyticsProcessingAllowed','saleOfDataAllowed'];
      if (!p || names.some(name => typeof p[name] !== 'function')) return null;
      return names.every(name => p[name]() === true);
    } catch (_) { return null; }
  }
  function tiktokProduction() {
    try {
      const u = new URL(location.href);
      return window.Shopify?.theme?.role === 'main' && !window.Shopify?.designMode &&
        u.protocol === 'https:' && ['pinmetoys.com','www.pinmetoys.com'].includes(u.hostname) &&
        !['preview_theme_id','preview_key','_fd','_ab'].some(key => u.searchParams.has(key)) &&
        !/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?(?:challenge|account|checkout|checkouts|orders|contact)(?:\/|$)/i.test(u.pathname);
    } catch (_) { return false; }
  }
  const tiktokIdentifier = (value, limit = 1000) => typeof value === 'string' && value.length <= limit && /^[A-Za-z0-9._~-]+$/.test(value) ? value : undefined;
  function tiktokRetryAfter(response) {
    try {
      const value = response.headers?.get('Retry-After'); if (!value) return null;
      const seconds = /^\d+$/.test(value.trim()) ? Number(value) : (Date.parse(value) - Date.now()) / 1000;
      return Number.isFinite(seconds) ? Math.min(60, Math.max(1, seconds)) * 1000 : null;
    } catch (_) { return null; }
  }
  function tiktokSafeUrl(value, referrer = false) {
    try {
      const u = new URL(value);
      if (!['http:','https:'].includes(u.protocol) || u.username || u.password) return undefined;
      if (!['pinmetoys.com','www.pinmetoys.com'].includes(u.hostname)) return referrer ? u.origin : undefined;
      if (u.protocol !== 'https:') return undefined;
      const path = /^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?(?:(?:products|pages|collections|policies)\/[a-z0-9-]{1,160}\/?|blogs\/[a-z0-9-]{1,100}(?:\/[a-z0-9-]{1,160})?\/?|(?:cart|search)\/?)?$/i.test(u.pathname) ? u.pathname : '/';
      // Tracking URLs never carry emails, native form return tokens or arbitrary query data.
      return u.origin + path;
    } catch (_) { return undefined; }
  }
  function clearTiktok() {
    if (tiktokTimer) clearTimeout(tiktokTimer);
    tiktokTimer = null;
    for (const item of tiktokQueue.values()) item.abort?.abort();
    tiktokQueue.clear(); tiktokSent.clear(); tiktokContext = null;
    try { sessionStorage.removeItem(tiktokContextKey); sessionStorage.removeItem(tiktokSentKey); } catch (_) {}
  }
  function observeTiktok() {
    try {
      const privacy = tiktokPrivacy();
      if (privacy === false) { clearTiktok(); return; }
      if (privacy !== true || !tiktokProduction()) return;
      if (tiktokContext && Date.now() - tiktokContext.capturedAt >= 86400000) tiktokContext = null;
      if (!tiktokContext) {
        try {
          const saved = JSON.parse(sessionStorage.getItem(tiktokContextKey) || 'null');
          if (saved?.version === 1 && Number.isInteger(saved.capturedAt) && saved.capturedAt <= Date.now() && Date.now() - saved.capturedAt < 86400000) {
            tiktokContext = { version:1, capturedAt:saved.capturedAt, ttclid:tiktokIdentifier(saved.ttclid), referrer:tiktokSafeUrl(saved.referrer, true) };
          }
        } catch (_) {}
      }
      const u = new URL(location.href), click = tiktokIdentifier(u.searchParams.get('ttclid'));
      if (click && click !== tiktokContext?.ttclid) {
        tiktokContext = { version:1, capturedAt:Date.now(), ttclid:click, referrer:tiktokSafeUrl(document.referrer, true) };
      } else if (!tiktokContext) {
        tiktokContext = { version:1, capturedAt:Date.now(), referrer:tiktokSafeUrl(document.referrer, true) };
      }
      // Session-only persistence survives Shopify's native verification return.
      try { sessionStorage.setItem(tiktokContextKey, JSON.stringify(tiktokContext)); } catch (_) {}
    } catch (_) { /* Optional attribution never interrupts the form. */ }
  }
  function tiktokAlreadySent(id) {
    try {
      const saved = JSON.parse(sessionStorage.getItem(tiktokSentKey) || '[]');
      if (Array.isArray(saved)) for (const row of saved.slice(-50)) {
        if (Array.isArray(row) && /^pinme_lead_[a-f0-9-]{36}$/.test(row[0]) && Number.isInteger(row[1]) && row[1] <= Date.now() / 1000 + 60 && Date.now() / 1000 - row[1] <= tiktokMaxAge) tiktokSent.set(row[0], row[1]);
      }
    } catch (_) {}
    return tiktokSent.has(id);
  }
  function rememberTiktok(id, time) {
    tiktokSent.set(id, time);
    for (const [key, when] of tiktokSent) if (Date.now() / 1000 - when > tiktokMaxAge) tiktokSent.delete(key);
    try { sessionStorage.setItem(tiktokSentKey, JSON.stringify([...tiktokSent].slice(-50))); } catch (_) {}
  }
  function queueTiktok(c, lead) {
    try {
      if (!tiktokProduction() || tiktokPrivacy() === false || !/^v1\.[a-f0-9-]{36}\.[a-f0-9]{64}$/.test(lead.relayToken || '')) return;
      if (tiktokQueue.has(lead.eventId) || tiktokSent.has(lead.eventId)) return;
      const base = new URL(c.endpoint);
      // Only the store's existing signup service may receive the signed receipt.
      if (base.origin !== 'https://pinme-community-service.gudaoa9261.chatgpt.site') return;
      tiktokQueue.set(lead.eventId, { lead:{...lead,source:c.source}, url:base.origin + '/api/marketing/tiktok-subscribe', attempts:0, nextAt:0, abort:null });
    } catch (_) {}
  }
  function scheduleTiktok() {
    if (tiktokTimer) clearTimeout(tiktokTimer);
    tiktokTimer = null;
    if (!tiktokQueue.size || tiktokPrivacy() !== true || !tiktokProduction()) return;
    const ready = [...tiktokQueue.values()].filter(item => !item.abort && item.attempts <= tiktokRetryDelays.length);
    if (ready.length) tiktokTimer = setTimeout(() => { tiktokTimer = null; flushTiktok(); }, Math.max(0, Math.min(...ready.map(item => item.nextAt)) - Date.now()));
  }
  function flushTiktok() {
    try {
      const privacy = tiktokPrivacy();
      if (privacy === false) { clearTiktok(); return; }
      if (privacy !== true || !tiktokProduction()) return;
      observeTiktok();
      if (navigator.onLine === false || document.visibilityState === 'hidden') return;
      for (const [id, item] of tiktokQueue) {
        if (Date.now() / 1000 - item.lead.eventTime > tiktokMaxAge || tiktokAlreadySent(id)) { tiktokQueue.delete(id); continue; }
        if (item.abort || Date.now() < item.nextAt) continue;
        if (item.attempts > tiktokRetryDelays.length) { tiktokQueue.delete(id); continue; }
        const abort = new AbortController(); item.abort = abort; item.attempts++;
        const page = {url:tiktokSafeUrl(location.href),referrer:tiktokContext?.referrer || tiktokSafeUrl(document.referrer, true) || ''};
        if (!page.url) { tiktokQueue.delete(id); continue; }
        let ttp;
        try { ttp = tiktokIdentifier(decodeURIComponent(document.cookie.split(';').map(part => part.trim()).find(part => part.startsWith('_ttp='))?.slice(5) || ''), 256); } catch (_) {}
        const lead = item.lead;
        const body = {eventId:id,eventTime:lead.eventTime,topicType:lead.topicType,topicId:lead.topicId,purpose:lead.purpose,source:lead.source,environment:'production',relayToken:lead.relayToken,consent:{marketing:true,analytics:true,saleOfData:true},page,...(tiktokContext?.ttclid ? {ttclid:tiktokContext.ttclid} : {}),...(ttp ? {ttp} : {})};
        let retryAfter = null;
        const timeout = setTimeout(() => abort.abort(), 10000);
        fetch(item.url, {method:'POST',headers:{Accept:'application/json','Content-Type':'application/json'},credentials:'omit',cache:'no-store',body:JSON.stringify(body),signal:abort.signal}).then(async response => {
          retryAfter = tiktokRetryAfter(response);
          let data; try { data = await response.json(); } catch (_) { throw Error('Unconfirmed tracking response'); }
          if (response.status === 200 && data?.accepted === true && ['sent','already_sent'].includes(data.status)) {
            if (tiktokPrivacy() === true) rememberTiktok(id, lead.eventTime);
            tiktokQueue.delete(id); return;
          }
          if (response.status === 202 && ['ignored','disabled','exhausted'].includes(data?.status)) { tiktokQueue.delete(id); return; }
          if ([400,401,403,404,410,422].includes(response.status)) { tiktokQueue.delete(id); return; }
          throw Error('Tracking retry');
        }).catch(() => {}).finally(() => {
          clearTimeout(timeout); item.abort = null;
          if (tiktokQueue.has(id)) {
            if (item.attempts > tiktokRetryDelays.length || tiktokPrivacy() === false) tiktokQueue.delete(id);
            else item.nextAt = Date.now() + (retryAfter ?? tiktokRetryDelays[item.attempts - 1]);
          }
          scheduleTiktok();
        });
      }
      scheduleTiktok();
    } catch (_) { /* No tracking error changes a successful signup. */ }
  }
  document.addEventListener('visitorConsentCollected', () => { observeTiktok(); flushTiktok(); });
  window.addEventListener('online', flushTiktok);
  document.addEventListener('visibilitychange', () => { if (document.visibilityState !== 'hidden') flushTiktok(); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', observeTiktok, {once:true});
  else observeTiktok();
  if (tiktokPrivacy() === null && typeof window.Shopify?.loadFeatures === 'function') {
    try { window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.2'}], error => { if (!error) { observeTiktok(); flushTiktok(); } }); } catch (_) {}
  }
  function flushLeads() {
    flushTiktok();
    try {
      const privacy = window.Shopify?.customerPrivacy;
      if (privacy?.marketingAllowed?.() !== true || privacy?.analyticsProcessingAllowed?.() !== true || privacy?.saleOfDataAllowed?.() !== true) return;
      if (typeof window.Shopify?.analytics?.publish !== 'function') return;
      for (const [id, lead] of pendingLeads) {
        if (Date.now() / 1000 - lead.eventTime > 900) { pendingLeads.delete(id); continue; }
        if (publishedLeads.has(id)) { pendingLeads.delete(id); continue; }
        if (publishingLeads.has(id)) continue;
        publishingLeads.add(id);
        let accepted;
        try {
          accepted = window.Shopify.analytics.publish('pinme:lead_confirmed', {
            eventId:id, ...(lead.productId ? {productId:lead.productId} : {}), eventTime:lead.eventTime,
            topicType:lead.topicType, topicId:lead.topicId, purpose:lead.purpose, source:lead.source, environment:'production',
          });
        } catch (_) { publishingLeads.delete(id); continue; }
        Promise.resolve(accepted).then(result => {
          if (result !== false) { publishedLeads.add(id); pendingLeads.delete(id); }
        }).catch(() => {}).finally(() => publishingLeads.delete(id));
      }
    } catch (_) { /* Tracking cannot change the signup result. */ }
  }
  function publishConfirmedLeads(c, data) {
    try {
      const url = new URL(location.href), theme = window.Shopify?.theme;
      if (theme?.role !== 'main' || window.Shopify?.designMode || url.searchParams.has('preview_theme_id') || url.searchParams.has('preview_key')) return;
      if (!['pinmetoys.com', 'www.pinmetoys.com'].includes(url.hostname) || url.protocol !== 'https:') return;
      if (!((c.topicType === 'newsletter' && c.purpose === 'newsletter') || (['product','bundle'].includes(c.topicType) && c.purpose === 'launch_notice'))) return;
      for (let lead of Array.isArray(data.leadEvents) ? data.leadEvents : []) {
        // Accept the already-deployed v1 product receipt during the rolling upgrade.
        if (!lead.topicType && c.topicType === 'product' && ['15881569534025','15898213449801'].includes(lead.productId)) lead = {...lead,topicType:'product',topicId:lead.productId,purpose:'launch_notice'};
        if (!/^pinme_lead_[a-f0-9-]{36}$/.test(lead.eventId || '') || lead.topicType !== c.topicType || lead.topicId !== c.topicId || lead.purpose !== c.purpose || !Number.isInteger(lead.eventTime)) continue;
        if (lead.productId && lead.productId !== c.productId && !(c.topicType === 'product' && lead.productId === c.topicId)) continue;
        if (lead.eventTime > Date.now() / 1000 + 60 || Date.now() / 1000 - lead.eventTime > 900) continue;
        pendingLeads.set(lead.eventId, {...lead,source:c.source});
        queueTiktok(c, lead);
      }
      flushLeads();
      if (pendingLeads.size && !window.Shopify?.customerPrivacy) window.Shopify?.loadFeatures?.([{name:'consent-tracking-api',version:'0.2'}], error => { if (!error) flushLeads(); });
    } catch (_) { /* No email or signed authentication is published to pixels. */ }
  }
  document.addEventListener('visitorConsentCollected', flushLeads);
  const config = form => { try { const c = JSON.parse(form.querySelector('[data-email-interest-config]')?.textContent || 'null'); if (c?.labels) { const text = document.createElement('textarea'); Object.keys(c.labels).forEach(key => { text.innerHTML = String(c.labels[key]); c.labels[key] = text.value; }); } return c; } catch (_) { return null; } };
  const validAuth = a => a && /^\d+$/.test(String(a.customerId)) && /^[a-f0-9]{64}$/.test(a.signature || '') && Number.isFinite(Number(a.issuedAt));
  const token = a => {
    const bytes = new TextEncoder().encode(JSON.stringify(a)); let text = ''; bytes.forEach(b => { text += String.fromCharCode(b); });
    return 'Pinme ' + btoa(text).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
  };
  const endpoint = c => { try { const u = new URL(c.endpoint); return u.protocol === 'https:' && !u.username && !u.password ? u.origin + u.pathname.replace(/\/$/, '') : null; } catch (_) { return null; } };
  const valid = c => !!c && !!endpoint(c) && /^[a-f0-9]{64}$/.test(c.contextSignature || '') && ['newsletter','product','bundle'].includes(c.topicType) && ['newsletter','launch_notice'].includes(c.purpose);
  async function request(url, init, signal, timeoutMs = 12000) {
    const abort = new AbortController(), cancel = () => abort.abort(), timer = setTimeout(cancel, timeoutMs);
    signal?.addEventListener('abort', cancel, { once:true }); if (signal?.aborted) abort.abort();
    try {
      const response = await fetch(url, { ...init, credentials:init.credentials || 'omit', cache:'no-store', signal:abort.signal });
      let data; try { data = await response.json(); } catch (_) { throw Error('Unconfirmed response'); }
      if (!response.ok) { const error = Error('Request unavailable'); error.status = response.status; error.code = data?.error?.code; throw error; }
      return data;
    } finally { clearTimeout(timer); signal?.removeEventListener('abort', cancel); }
  }
  function guestState(base) {
    if (!guests.has(base)) guests.set(base, { token:null, expiresAt:0, flight:null });
    return guests.get(base);
  }
  const guestValid = g => /^[A-Za-z0-9_-]{32,256}$/.test(g?.token || '') && Number(g?.expiresAt) > Date.now() / 1000 + 10;
  function clearGuest(base) { const g = guestState(base); g.token = null; g.expiresAt = 0; try { localStorage.removeItem('pinme.community.guest.v1:' + base); } catch (_) {} }
  async function ensureGuest(base, signal) {
    const g = guestState(base), key = 'pinme.community.guest.v1:' + base;
    const reuse = () => { try { const value = JSON.parse(localStorage.getItem(key) || 'null'); if (value && guestValid(value)) { g.token = value.token; g.expiresAt = value.expiresAt; } } catch (_) {} };
    reuse(); if (guestValid(g)) return g.token; if (g.flight) return g.flight;
    const issue = async () => {
      reuse(); if (guestValid(g)) return g.token;
      const value = await request(base + '/api/community/guests', { method:'POST', headers:{ Accept:'application/json', 'Content-Type':'application/json' }, body:'{}' }, signal);
      if (!guestValid(value)) throw Error('Unconfirmed guest');
      g.token = value.token; g.expiresAt = value.expiresAt;
      try { localStorage.setItem(key, JSON.stringify({ token:g.token, expiresAt:g.expiresAt })); } catch (_) {}
      return g.token;
    };
    g.flight = (navigator.locks?.request ? navigator.locks.request(key, issue) : issue()).finally(() => { g.flight = null; });
    return g.flight;
  }
  async function record(form, {signal, experimentContext} = {}) {
    const c = config(form); if (!valid(c)) throw Error(c?.labels?.unavailable || 'Email preferences unavailable');
    const email = form.querySelector('[name="contact[email]"]')?.value.trim(); if (!email) throw Error(c.labels.error);
    const body = { email, source:c.source, topicType:c.topicType, topicId:c.topicId, productId:c.productId || undefined, variantId:c.variantId || undefined, purpose:c.purpose, consent:true, contextSignature:c.contextSignature };
    const serialized = JSON.stringify(body), previous = requests.get(form);
    let entry = previous?.consentBody === serialized ? previous : null;
    if (!entry) {
      try { const attribution = window.PinmeEmailAttribution?.snapshot(c.attributionContext); if (attribution) body.attribution = attribution; } catch (_) {}
      entry = { consentBody:serialized, body:JSON.stringify(body), key:crypto.randomUUID(), flight:null, recorded:false };
    }
    requests.set(form, entry); if (entry.recorded) return { recorded:true }; if (entry.flight) return entry.flight;
    const base = endpoint(c);
    entry.flight = (async () => {
      let auth = c.auth;
      const refreshAuth = async () => {
        const refresh = new URL(c.authRefreshUrl, location.href); if (refresh.origin !== location.origin) throw Error(c.labels.error);
        const response = await request(refresh.href, { credentials:'same-origin', headers:{Accept:'application/json'} }, signal);
        const next = response.auth; if (!validAuth(next)) throw Error(c.labels.error); auth = next;
      };
      if (validAuth(auth) && Date.now() / 1000 - Number(auth.issuedAt) > 13 * 60) await refreshAuth();
      let renewed = false;
      while (true) {
        const authorization = validAuth(auth) ? token(auth) : 'PinmeGuest ' + await ensureGuest(base, signal);
        try {
          // Refresh purpose permissions at the actual write; optional analytics never delays signup.
          let requestBody = entry.consentBody;
          let submittedExperimentContext = experimentContext === undefined ? undefined : null;
          let explicitExperimentContext = experimentContext !== undefined;
          let analyticsPermissionAtWrite = null;
          try {
            const optional = JSON.parse(entry.body), purpose = window.PinmeEmailAttribution?.permissions?.() || {analytics:false,marketing:false,advertising:false};
            try {
              const privacy = window.Shopify?.customerPrivacy;
              const value = typeof privacy?.analyticsProcessingAllowed === 'function' ? privacy.analyticsProcessingAllowed() : null;
              analyticsPermissionAtWrite = value === true ? true : value === false ? false : null;
            } catch (_) { analyticsPermissionAtWrite = null; }
            purpose.analytics = purpose.analytics === true && analyticsPermissionAtWrite === true;
            purpose.advertising = purpose.advertising === true && purpose.analytics;
            if (purpose.marketing !== true) delete optional.attribution;
            else {
              try {
                const fresh = window.PinmeEmailAttribution?.snapshot(c.attributionContext);
                if (fresh) optional.attribution = fresh;
              } catch (_) { /* Attribution is independent of experiment linkage. */ }
            }
            optional.processingPermissions = purpose;
            // Resolve after authentication, when the privacy API may have finished loading.
            const resolvedContext = purpose.analytics === true
              ? (typeof experimentContext === 'function' ? experimentContext() : experimentContext)
              : null;
            explicitExperimentContext = experimentContext !== undefined && resolvedContext !== undefined;
            const signupContext = purpose.analytics === true && resolvedContext === undefined
              ? window.PinmeMoonlitExperimentCollector?.signupContext?.(c, form) : resolvedContext;
            if (purpose.analytics === true && signupContext) optional.experimentContext = signupContext;
            requestBody = JSON.stringify(optional);
            // Optional metadata must not push a valid signup over the API's UTF-8 byte limit.
            if (new TextEncoder().encode(requestBody).byteLength > 8192) {
              delete optional.attribution;
              requestBody = JSON.stringify(optional);
              if (new TextEncoder().encode(requestBody).byteLength > 8192) requestBody = entry.consentBody;
            }
            // Carry the context actually written, including an explicit absence,
            // so a native return cannot attach an old receipt to a newer round.
            const written = JSON.parse(requestBody);
            if (written.experimentContext) submittedExperimentContext = written.experimentContext;
            else if (explicitExperimentContext || purpose.analytics !== true || signupContext) submittedExperimentContext = null;
          } catch (_) { /* The original consent receipt remains a valid fallback. */ }
          const data = await request(base + '/api/email/interests', { method:'POST', headers:{Accept:'application/json','Content-Type':'application/json',Authorization:authorization,'Idempotency-Key':entry.key}, body:requestBody }, signal);
          if (data.recorded !== true || !data.receiptId) throw Error('Unconfirmed preference');
          entry.recorded = true; form.dataset.emailInterestRecorded = 'true';
          try {
            const page = new URL(location.href);
            if (window.Shopify?.theme?.role === 'main' && !window.Shopify?.designMode &&
              page.protocol === 'https:' && ['pinmetoys.com','www.pinmetoys.com'].includes(page.hostname) &&
              !['preview_theme_id','preview_key','_fd','_ab'].some(name => page.searchParams.has(name)) &&
              navigator.globalPrivacyControl !== true && window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true &&
              typeof window.clarity === 'function' && typeof data.receiptId === 'string' &&
              /^[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12}$/i.test(data.receiptId)) {
              window.clarity('set', 'pinme_signup_receipt', data.receiptId);
            }
          } catch (_) {}
          publishConfirmedLeads(c, data);
          try { document.dispatchEvent(new CustomEvent('pinme:interest-recorded', { detail: { receiptId: data.receiptId, topicType: c.topicType, topicId: c.topicId, purpose: c.purpose, source: c.source, formId: form.id || '', ...(!explicitExperimentContext ? {} : {experimentContextExplicit:true,experimentContext:submittedExperimentContext || null,analyticsPermissionAtWrite}) } })); } catch (_) {}
          return data;
        } catch (error) {
          if (!renewed && validAuth(auth) && error.status === 401) { renewed = true; await refreshAuth(); continue; }
          if (!renewed && !validAuth(auth) && [401,409].includes(error.status) && ['GUEST_INVALID','GUEST_EXPIRED','GUEST_ALREADY_CLAIMED'].includes(error.code)) { renewed = true; clearGuest(base); continue; }
          if (error.code === 'CONSENT_CHANGED') requests.delete(form);
          throw error;
        }
      }
    })().finally(() => { entry.flight = null; });
    return entry.flight;
  }
  function enhance(form) {
    if (controllers.has(form)) return;
    let c = config(form); if (!c || c.purpose === 'newsletter') return;
    const email = form.querySelector('[name="contact[email]"]'), button = form.querySelector('[type=submit]'), status = form.querySelector('[data-email-interest-status]');
    if (!email || !button || !status) return;
    const abort = new AbortController(), label = button.textContent; let active = null, pending = false, confirmed = false;
    const set = (state, message = '') => {
      pending = state === 'pending'; button.disabled = pending || state === 'success' || !valid(c); email.readOnly = pending || state === 'success';
      if (pending) form.setAttribute('aria-busy','true'); else form.removeAttribute('aria-busy'); form.dataset.emailInterestState = state;
      button.textContent = pending ? c.labels.pending : state === 'success' ? c.labels.joined : label;
      status.hidden = !message; status.textContent = message; status.classList.toggle('is-error', state === 'error'); status.setAttribute('role', state === 'error' ? 'alert' : 'status');
    };
    set(valid(c) ? 'idle' : 'error', valid(c) ? '' : c.labels.unavailable);
    form.addEventListener('submit', event => {
      event.preventDefault(); event.stopImmediatePropagation(); if (pending || confirmed || !form.reportValidity()) return;
      active = new AbortController(); set('pending');
      record(form, {signal:active.signal}).then(() => { if (!abort.signal.aborted) { confirmed = true; set('success'); } }).catch(() => { if (!abort.signal.aborted && !active?.signal.aborted) set('error', c.labels.error); }).finally(() => { active = null; });
    }, {capture:true, signal:abort.signal});
    form.addEventListener('focusin', () => { if (valid(c) && !validAuth(c.auth)) ensureGuest(endpoint(c), abort.signal).catch(() => {}); }, {once:true, signal:abort.signal});
    const controller = { refresh() { if (pending) return; c = config(form); confirmed = false; delete form.dataset.emailInterestRecorded; set(valid(c) ? 'idle' : 'error', valid(c) ? '' : c?.labels?.unavailable); }, destroy() { abort.abort(); active?.abort(); controllers.delete(form); } }; controllers.set(form, controller);
  }
  function init(scope = document) { const forms = [...(scope.matches?.('[data-email-interest-form]') ? [scope] : []), ...scope.querySelectorAll('[data-email-interest-form]')]; forms.forEach(enhance); }
  window.PinmeEmailInterests = { record, config, init, refresh(form) { controllers.get(form)?.refresh(); }, warm(form) { const c = config(form); if (valid(c) && !validAuth(c.auth)) return ensureGuest(endpoint(c)); return Promise.resolve(); }, destroy(scope) { controllers.forEach((c,f) => { if (f === scope || scope.contains(f)) c.destroy(); }); } };
  document.addEventListener('shopify:section:load', e => init(e.target));
  document.addEventListener('shopify:section:unload', e => window.PinmeEmailInterests.destroy(e.target));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), {once:true}); else init();
})();





